import { Reducer } from 'redux'
import { TasksActionTypes } from '../actions/tasks.actions'
import { initialTasksStoreState, TasksStoreModel } from '../store.model'

export const tasksReducer: Reducer<TasksStoreModel> = (state = initialTasksStoreState, action) => {
  switch (action.type) {
    case TasksActionTypes.STORE_SHOW_TASKS:
      return { ...state, showTasks: action.payload }
    case TasksActionTypes.STORE_SHOW_FILTER_CARD:
      return { ...state, showSearchFilter: action.payload }
    case TasksActionTypes.STORE_TASKS_SEARCHFILTERS:
      return { ...state, tasksSearchFilters: action.payload }
    case TasksActionTypes.STORE_TASKS_DATATABLE:
      return { ...state, tasksDataTable: action.payload }
    default:
      return state
  }
}
